import React from 'react';
import { observer } from 'mobx-react';
import { Checkbox, CheckboxProps } from 'radiance-ui';
import { css } from '@emotion/react';

import { FormFieldType } from 'jsx/components/formHelper';

import FieldWrapper from '../fieldWrapper';

const CheckboxField: React.FC<{
  field: FormFieldType<boolean>;
  onClick: Exclude<CheckboxProps['onClick'], undefined>;
  label?: string;
}> = ({ field, children, onClick, label }) => (
  <FieldWrapper field={field} hideLabel hideErrorIcon>
    <Checkbox
      onClick={onClick}
      checked={!!field.value}
      css={css`
        margin-bottom: 0;
      `}
      data-test-id="checkbox"
      aria-label={typeof children === 'undefined' ? label : undefined}
    >
      {children}
    </Checkbox>
  </FieldWrapper>
);

export default observer(CheckboxField);
